import { AccountModel } from '../account';

export class UpdateModel {
  updated: Date;
  accountId: string;
  update: boolean;
  user: string;
  account: AccountModel;

  constructor(data?: Partial<UpdateModel>) {
    Object.assign(this, data);
  }
}

export interface RevokeResponse {
  terminals: string[];
  count: number;
}

export class UpdateInfoModel {
  info: string;

  constructor(data?: Partial<UpdateInfoModel>) {
    Object.assign(this, data);
  }
}
